<ion-card>
  <ion-card-content>
    <ion-grid *ngIf="value.length > 0">
      <ion-row class="grid">
        <ion-col *ngFor="let item of [0, 1, 2, 3]; let i = index" [class]="'item' + i" size="4">
          <div class="sq">
            <div class="content">
              <div class="quantity">
                <app-quantity
                  [isVertical]="true"
                  [min]="0"
                  [max]="5"
                  [quantity]="value[i]"
                  (quantityChange)="changeItem(i, $event)"
                ></app-quantity>
              </div>
            </div>
          </div>
        </ion-col>
        <ion-col class="center" size="4">
          <ion-img [src]="'/assets/logos/gana-gato.svg'"></ion-img>
        </ion-col>
        <ion-col *ngFor="let item of [4, 5, 6, 7]; let i = index" [class]="'item' + (i + 4)" size="4">
          <div class="sq">
            <div class="content">
              <div class="quantity">
                <app-quantity
                  [isVertical]="true"
                  [min]="0"
                  [max]="5"
                  [quantity]="value[i + 4]"
                  (quantityChange)="changeItem(i + 4, $event)"
                ></app-quantity>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
